import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatToolbar } from '@angular/material/toolbar';
import { UserSessionService } from '../../services/user.service';
import { UserEnseigneService } from '../../services/userEnseigne.service';
import { CommonModule } from '@angular/common';
import { distinctUntilChanged, filter, Subject, switchMap, takeUntil } from 'rxjs';

@Component({
  selector: 'app-help',
  standalone: true,
  styleUrl: './help.component.scss',
  imports: [MatToolbar, CommonModule],
  templateUrl: './help.component.html',

})

export class HelpComponent implements OnInit, OnDestroy {
  activiteAdherent!: string;
  filialeAdherent!: string;
  emailsResponsables!: string;
  private readonly _destroying$: Subject<void> = new Subject();
    constructor(
      private readonly userSessionService: UserSessionService,
      private readonly userEnseigneService: UserEnseigneService,
    ) {}
  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }
  ngOnInit(): void {
  this.activiteAdherent = this.userSessionService.getActivite();

  if (this.activiteAdherent === 'gpo') {
    this.userSessionService.filiale$
      .pipe(
        filter((f): f is string => f !== null),
        distinctUntilChanged(),
        switchMap(filiale => {
          this.filialeAdherent = filiale.toLowerCase();
          return this.userEnseigneService.fetchEmailsByEnseigne(this.filialeAdherent);
        }),
        takeUntil(this._destroying$),
      )
      .subscribe({
        next: emails => {
          this.emailsResponsables = Array.isArray(emails) && emails.length > 0 ? emails[0] : '';
        },
        error: err => {
          console.error('Erreur récupération emails:', err);
        },
      });
  }

}


}
